var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property, html, unsafeCSS, LitElement } from 'lit-element';
import { customElement } from './../../libs/decorators';
import { createLabel } from './parts';
import styles from './style.scss';
const width = (value) => `width: ${value}%`;
let ProgressBar = class ProgressBar extends LitElement {
    constructor() {
        super(...arguments);
        this.label = 'Label';
        this.value = 50;
        this.display = undefined;
        this.format = '%';
        this.nodigits = false;
        this.disabled = false;
    }
    render() {
        return html `      
      <div>
        ${createLabel(this.label, this.value, this.nodigits, this.format, this.display, this.disabled)}
        <div class="progress-bar">
          <div class="bar-background">
            <div 
              class="bar-track"
              ?disabled=${this.disabled} 
              style=${width(this.value)}
            ></div>
          </div>
        </div>
      </div>
    `;
    }
};
ProgressBar.styles = unsafeCSS(styles);
__decorate([
    property({ type: String })
], ProgressBar.prototype, "label", void 0);
__decorate([
    property({ type: Number })
], ProgressBar.prototype, "value", void 0);
__decorate([
    property({ type: Number })
], ProgressBar.prototype, "display", void 0);
__decorate([
    property({ type: String })
], ProgressBar.prototype, "format", void 0);
__decorate([
    property({ type: Boolean })
], ProgressBar.prototype, "nodigits", void 0);
__decorate([
    property({ type: Boolean })
], ProgressBar.prototype, "disabled", void 0);
ProgressBar = __decorate([
    customElement('amber-progress-bar')
], ProgressBar);
export { ProgressBar };
